// extracted by mini-css-extract-plugin
export var brightBlue = "Icon-module--brightBlue--bc43c";
export var circleblack = "Icon-module--circleblack--36e7b";
export var circlelightBlue = "Icon-module--circlelightBlue--b5ec0";
export var circlewhite = "Icon-module--circlewhite--f8305";
export var dark = "Icon-module--dark--03d56";
export var darkBlue = "Icon-module--darkBlue--70a30";
export var hasBackground = "Icon-module--hasBackground--28067";
export var icon = "Icon-module--icon--600d8";
export var orange = "Icon-module--orange--637b8";
export var seaGreen = "Icon-module--seaGreen--f2f4f";
export var white = "Icon-module--white--2b3a3";
export var whiteCircle = "Icon-module--whiteCircle--58afc";